import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './POSTAUCT_Lien_Tax_Clearance.css';

const POSTAUCT_Lien_Tax_Clearance = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"POSTAUCT_LIEN_TAX_CLEARANCE",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	POSTAUCT_LIEN_TAX_CLEARANCE:-1
  });


  const [POSTAUCT_LIEN_TAX_CLEARANCE, setPOSTAUCT_LIEN_TAX_CLEARANCE] = React.useState(null);
  const [POSTAUCT_LIEN_TAX_CLEARANCE_D, setPOSTAUCT_LIEN_TAX_CLEARANCE_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Post-Auction Lien and Tax Clearance');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/POSTAUCT_Lien_Tax_Clearance',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewPOSTAUCT_LIEN_TAX_CLEARANCE(clientInfo,"OpenNew");

		navigate('/POSTAUCT_Lien_Tax_Clearance',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/POSTAUCT_Lien_Tax_Clearance_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(POSTAUCT_LIEN_TAX_CLEARANCE));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewPOSTAUCT_LIEN_TAX_CLEARANCE(clientInfo,"OpenNew");
		}
		navigate('/POSTAUCT_Lien_Tax_Clearance',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/POSTAUCT_Lien_Tax_Clearance_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/POSTAUCT_Lien_Tax_Clearance_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/POSTAUCT_Lien_Tax_Clearance_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(POSTAUCT_LIEN_TAX_CLEARANCE));
		if(Temp_Data2.status!="New"){
			handleDeletePOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data2);
			navigate('/POSTAUCT_Lien_Tax_Clearance#New',{replace:true});
		} 
		else 
			navigate('/POSTAUCT_Lien_Tax_Clearance',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/POSTAUCT_Lien_Tax_Clearance',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/POSTAUCT_Lien_Tax_Clearance',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/POSTAUCT_Lien_Tax_Clearance',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/POSTAUCT_Lien_Tax_Clearance',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!POSTAUCT_LIEN_TAX_CLEARANCE) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_${i}_SECTION`;
	  const headerId = `#POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {

    initRef.current.dataTableHandled = true;
  }  

  }, [POSTAUCT_LIEN_TAX_CLEARANCE]) ;


  
  
  var Ids = [];
  for(var Ele in POSTAUCT_LIEN_TAX_CLEARANCE){
	  for(var Sec in POSTAUCT_LIEN_TAX_CLEARANCE[Ele]){
		if(Sec == "id")
			Ids.push(POSTAUCT_LIEN_TAX_CLEARANCE[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(POSTAUCT_LIEN_TAX_CLEARANCE[Ele]["status"]);
		else if(Array.isArray(POSTAUCT_LIEN_TAX_CLEARANCE[Ele][Sec]))
			  for(var Row in POSTAUCT_LIEN_TAX_CLEARANCE[Ele][Sec])  // Convert to POSTAUCT_LIEN_TAX_CLEARANCE[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in POSTAUCT_LIEN_TAX_CLEARANCE[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["POSTAUCT_LIEN_TAX_CLEARANCE"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewPOSTAUCT_LIEN_TAX_CLEARANCE(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/POSTAUCT_LIEN_TAX_CLEARANCE`).then((response1) => {
		if(!POSTAUCT_LIEN_TAX_CLEARANCE) 
			setPOSTAUCT_LIEN_TAX_CLEARANCE(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/POSTAUCT_LIEN_TAX_CLEARANCE_D`).then((response2) => {
			setPOSTAUCT_LIEN_TAX_CLEARANCE_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddPOSTAUCT_LIEN_TAX_CLEARANCE_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewPOSTAUCT_LIEN_TAX_CLEARANCE = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/POSTAUCT_LIEN_TAX_CLEARANCE/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setPOSTAUCT_LIEN_TAX_CLEARANCE(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataPOSTAUCT_LIEN_TAX_CLEARANCE = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/POSTAUCT_LIEN_TAX_CLEARANCE/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutPOSTAUCT_LIEN_TAX_CLEARANCE = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/POSTAUCT_LIEN_TAX_CLEARANCE/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostPOSTAUCT_LIEN_TAX_CLEARANCE = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/POSTAUCT_LIEN_TAX_CLEARANCE', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeletePOSTAUCT_LIEN_TAX_CLEARANCE = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/POSTAUCT_LIEN_TAX_CLEARANCE', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_LIEN_TAX_CLEARANCE));
	Temp_Data["1"]["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_1_0"]=value;
	//handleAddPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data,App_Data['POSTAUCT_LIEN_TAX_CLEARANCE']);
	Form_Data_onChange("1","POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_1_0",value,Temp_Data);
 	//handleLastDataPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data);
    setPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data);
 }; 
  
    
const POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_LIEN_TAX_CLEARANCE));
	Temp_Data["1"]["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_1_1"]=value;
	//handleAddPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data,App_Data['POSTAUCT_LIEN_TAX_CLEARANCE']);
	Form_Data_onChange("1","POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_1_1",value,Temp_Data);
 	//handleLastDataPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data);
    setPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data);
 }; 
  
    
const POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_LIEN_TAX_CLEARANCE));
	Temp_Data["1"]["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_1_2"]=value;
	//handleAddPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data,App_Data['POSTAUCT_LIEN_TAX_CLEARANCE']);
	Form_Data_onChange("1","POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_1_2",value,Temp_Data);
 	//handleLastDataPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data);
    setPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data);
 }; 
  
    
const POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_LIEN_TAX_CLEARANCE));
	Temp_Data["2"]["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_2_0"]=value;
	//handleAddPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data,App_Data['POSTAUCT_LIEN_TAX_CLEARANCE']);
	Form_Data_onChange("2","POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_2_0",value,Temp_Data);
 	//handleLastDataPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data);
    setPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data);
 }; 
  
    
const POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_LIEN_TAX_CLEARANCE));
	Temp_Data["2"]["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_2_1"]=value;
	//handleAddPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data,App_Data['POSTAUCT_LIEN_TAX_CLEARANCE']);
	Form_Data_onChange("2","POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_2_1",value,Temp_Data);
 	//handleLastDataPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data);
    setPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data);
 }; 
  

const POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_2_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_LIEN_TAX_CLEARANCE));
	Temp_Data["2"]["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_2_2"]=value;
	Form_Data_onChange("2","POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_2_2",value,Temp_Data);
 	//handleLastDataPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data);
    setPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data);
	//handleAddPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data,App_Data['POSTAUCT_LIEN_TAX_CLEARANCE']);
  }; 
  

    
const POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_3_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_LIEN_TAX_CLEARANCE));
	Temp_Data["3"]["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_3_0"]=value;
	//handleAddPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data,App_Data['POSTAUCT_LIEN_TAX_CLEARANCE']);
	Form_Data_onChange("3","POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_3_0",value,Temp_Data);
 	//handleLastDataPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data);
    setPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data);
 }; 
  

const POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_3_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_LIEN_TAX_CLEARANCE));
	Temp_Data["3"]["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_3_1"]=value;
	Form_Data_onChange("3","POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_3_1",value,Temp_Data);
 	//handleLastDataPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data);
    setPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data);
	//handleAddPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data,App_Data['POSTAUCT_LIEN_TAX_CLEARANCE']);
  }; 
  

    
const POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_LIEN_TAX_CLEARANCE));
	Temp_Data["4"]["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_4_0"]=value;
	//handleAddPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data,App_Data['POSTAUCT_LIEN_TAX_CLEARANCE']);
	Form_Data_onChange("4","POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_4_0",value,Temp_Data);
 	//handleLastDataPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data);
    setPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data);
 }; 
  

const POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_4_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_4_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_LIEN_TAX_CLEARANCE));
	Temp_Data["4"]["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_4_1"]=value;
	Form_Data_onChange("4","POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_4_1",value,Temp_Data);
 	//handleLastDataPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data);
    setPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data);
	//handleAddPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data,App_Data['POSTAUCT_LIEN_TAX_CLEARANCE']);
  }; 
  

    
const POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_LIEN_TAX_CLEARANCE));
	Temp_Data["5"]["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_0"]=value;
	//handleAddPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data,App_Data['POSTAUCT_LIEN_TAX_CLEARANCE']);
	Form_Data_onChange("5","POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_0",value,Temp_Data);
 	//handleLastDataPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data);
    setPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data);
 }; 
  
    
const POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_LIEN_TAX_CLEARANCE));
	Temp_Data["5"]["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_1"]=value;
	//handleAddPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data,App_Data['POSTAUCT_LIEN_TAX_CLEARANCE']);
	Form_Data_onChange("5","POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_1",value,Temp_Data);
 	//handleLastDataPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data);
    setPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data);
 }; 
  
    
const POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_LIEN_TAX_CLEARANCE));
	Temp_Data["5"]["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_2"]=value;
	//handleAddPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data,App_Data['POSTAUCT_LIEN_TAX_CLEARANCE']);
	Form_Data_onChange("5","POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_2",value,Temp_Data);
 	//handleLastDataPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data);
    setPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data);
 }; 
  
    
const POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_LIEN_TAX_CLEARANCE));
	Temp_Data["5"]["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_3"]=value;
	//handleAddPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data,App_Data['POSTAUCT_LIEN_TAX_CLEARANCE']);
	Form_Data_onChange("5","POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_3",value,Temp_Data);
 	//handleLastDataPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data);
    setPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data);
 }; 
  

const POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_LIEN_TAX_CLEARANCE));
	Temp_Data["5"]["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_4"]=value;
	Form_Data_onChange("5","POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_4",value,Temp_Data);
 	//handleLastDataPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data);
    setPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data);
	//handleAddPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data,App_Data['POSTAUCT_LIEN_TAX_CLEARANCE']);
  }; 
  

    
const POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_LIEN_TAX_CLEARANCE));
	Temp_Data["5"]["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_5"]=value;
	//handleAddPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data,App_Data['POSTAUCT_LIEN_TAX_CLEARANCE']);
	Form_Data_onChange("5","POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_5",value,Temp_Data);
 	//handleLastDataPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data);
    setPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data);
 }; 
  

const POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_LIEN_TAX_CLEARANCE));
	Temp_Data["9"]["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_9_0"]=value;
	Form_Data_onChange("9","POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_9_0",value,Temp_Data);
 	//handleLastDataPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data);
    setPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data);
	//handleAddPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data,App_Data['POSTAUCT_LIEN_TAX_CLEARANCE']);
  }; 
  

    
const POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_LIEN_TAX_CLEARANCE));
	Temp_Data["9"]["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_9_1"]=value;
	//handleAddPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data,App_Data['POSTAUCT_LIEN_TAX_CLEARANCE']);
	Form_Data_onChange("9","POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_9_1",value,Temp_Data);
 	//handleLastDataPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data);
    setPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data);
 }; 
  
    
const POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_LIEN_TAX_CLEARANCE));
	Temp_Data["9"]["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_9_2"]=value;
	//handleAddPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data,App_Data['POSTAUCT_LIEN_TAX_CLEARANCE']);
	Form_Data_onChange("9","POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_9_2",value,Temp_Data);
 	//handleLastDataPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data);
    setPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data);
 }; 
  
    
const POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_LIEN_TAX_CLEARANCE));
	Temp_Data["9"]["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_9_3"]=value;
	//handleAddPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data,App_Data['POSTAUCT_LIEN_TAX_CLEARANCE']);
	Form_Data_onChange("9","POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_9_3",value,Temp_Data);
 	//handleLastDataPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data);
    setPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data);
 }; 
  
    
const POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(POSTAUCT_LIEN_TAX_CLEARANCE));
	Temp_Data["9"]["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_9_4"]=value;
	//handleAddPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data,App_Data['POSTAUCT_LIEN_TAX_CLEARANCE']);
	Form_Data_onChange("9","POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_9_4",value,Temp_Data);
 	//handleLastDataPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data);
    setPOSTAUCT_LIEN_TAX_CLEARANCE(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!POSTAUCT_LIEN_TAX_CLEARANCE) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {

  }


  const updatedPOSTAUCT_LIEN_TAX_CLEARANCE =JSON.parse(JSON.stringify(POSTAUCT_LIEN_TAX_CLEARANCE));
  updatedPOSTAUCT_LIEN_TAX_CLEARANCE[Sec] = [...updatedPOSTAUCT_LIEN_TAX_CLEARANCE[Sec], newRow];
  setPOSTAUCT_LIEN_TAX_CLEARANCE(updatedPOSTAUCT_LIEN_TAX_CLEARANCE);
};

const handleDeleteRow = (sec,index) => {
  const updatedPOSTAUCT_LIEN_TAX_CLEARANCE = JSON.parse(JSON.stringify(POSTAUCT_LIEN_TAX_CLEARANCE));
  updatedPOSTAUCT_LIEN_TAX_CLEARANCE[sec].splice(index, 1);
  setPOSTAUCT_LIEN_TAX_CLEARANCE(updatedPOSTAUCT_LIEN_TAX_CLEARANCE);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Post-Auction Lien and Tax Clearance`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Post-Auction Lien/Tax Clearance ID`)} <span className="toggle-icon">^</span></h2>
            <div id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`POSTAUCT Lien Tax Clearance ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_1_0" type="text" className="form-control" placeholder="POSTAUCT Lien Tax Clearance ID" value={POSTAUCT_LIEN_TAX_CLEARANCE["1"][`POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_1_0`]} 
						onChange={POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter POSTAUCT Lien Tax Clearance ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Asset ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_1_1" type="text" className="form-control" placeholder="Asset ID" value={POSTAUCT_LIEN_TAX_CLEARANCE["1"][`POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_1_1`]} 
						onChange={POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Asset ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`POSTAUCT Acquisition Closing ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_1_2" type="text" className="form-control" placeholder="POSTAUCT Acquisition Closing ID" value={POSTAUCT_LIEN_TAX_CLEARANCE["1"][`POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_1_2`]} 
						onChange={POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter POSTAUCT Acquisition Closing ID`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_2_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Known Lien Count`)} <span className="toggle-icon">^</span></h2>
            <div id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_2_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '50ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Known Lien Count`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_2_0" type="text" className="form-control" placeholder="Known Lien Count" value={POSTAUCT_LIEN_TAX_CLEARANCE["2"][`POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_2_0`]} 
						onChange={POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_2_0_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_2_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '50ch' }}>
						 {t(`Enter Known Lien Count`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Known Lien Total USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_2_1" type="text" className="form-control" placeholder="Known Lien Total USD" value={POSTAUCT_LIEN_TAX_CLEARANCE["2"][`POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_2_1`]} 
						onChange={POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_2_1_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_2_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Known Lien Total USD`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Lien Clearance Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_2_2"  value={POSTAUCT_LIEN_TAX_CLEARANCE["2"][`POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_2_2`]} onChange={POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_2_2_Change} className="form-control" name="Lien Clearance Status"  >
						  <option value="Not Started">Not Started</option>
						  <option value="In Progress">In Progress</option>
						  <option value="Clear">Clear</option>
						  <option value="Issue Found">Issue Found</option>
						  <option value="Escalated">Escalated</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Lien Clearance Status
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_3_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Tax Delinquent Amount USD`)} <span className="toggle-icon">^</span></h2>
            <div id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_3_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Tax Delinquent Amount USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_3_0" type="text" className="form-control" placeholder="Tax Delinquent Amount USD" value={POSTAUCT_LIEN_TAX_CLEARANCE["3"][`POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_3_0`]} 
						onChange={POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_3_0_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_3_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Tax Delinquent Amount USD`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Tax Clearance Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_3_1"  value={POSTAUCT_LIEN_TAX_CLEARANCE["3"][`POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_3_1`]} onChange={POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_3_1_Change} className="form-control" name="Tax Clearance Status"  >
						  <option value="Not Started">Not Started</option>
						  <option value="In Progress">In Progress</option>
						  <option value="Clear">Clear</option>
						  <option value="Issue Found">Issue Found</option>
						  <option value="Escalated">Escalated</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Tax Clearance Status
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_4_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Clearance Document Link`)} <span className="toggle-icon">^</span></h2>
            <div id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_4_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '255ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Clearance Document Link`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_4_0" type="text" className="form-control" placeholder="Clearance Document Link" value={POSTAUCT_LIEN_TAX_CLEARANCE["4"][`POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_4_0`]} 
						onChange={POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_4_0_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_4_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '255ch' }}>
						 {t(`Enter Clearance Document Link`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Final Clearance Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_4_1"  value={POSTAUCT_LIEN_TAX_CLEARANCE["4"][`POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_4_1`]} onChange={POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_4_1_Change} className="form-control" name="Final Clearance Status"  >
						  <option value="Not Started">Not Started</option>
						  <option value="Pending">Pending</option>
						  <option value="Approved">Approved</option>
						  <option value="Rejected">Rejected</option>
						  <option value="Exception">Exception</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Final Clearance Status
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Submitted By`)} <span className="toggle-icon">^</span></h2>
            <div id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_0" type="text" className="form-control" placeholder="Submitted By" value={POSTAUCT_LIEN_TAX_CLEARANCE["5"][`POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_0`]} 
						onChange={POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_0_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Submitted By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_1" type="text" className="form-control" placeholder="Submitted At" value={POSTAUCT_LIEN_TAX_CLEARANCE["5"][`POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_1`]} 
						onChange={POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_1_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Submitted At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_2" type="text" className="form-control" placeholder="Reviewed By" value={POSTAUCT_LIEN_TAX_CLEARANCE["5"][`POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_2`]} 
						onChange={POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_2_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Reviewed By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_3" type="text" className="form-control" placeholder="Reviewed At" value={POSTAUCT_LIEN_TAX_CLEARANCE["5"][`POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_3`]} 
						onChange={POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_3_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Reviewed At`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Approval Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_4"  value={POSTAUCT_LIEN_TAX_CLEARANCE["5"][`POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_4`]} onChange={POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_4_Change} className="form-control" name="Approval Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Submitted">Submitted</option>
						  <option value="Under Review">Under Review</option>
						  <option value="Revision Requested">Revision Requested</option>
						  <option value="Approved">Approved</option>
						  <option value="Rejected">Rejected</option>
						  <option value="Withdrawn">Withdrawn</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Approval Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '3000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Approval Notes`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_5" type="text" className="form-control" placeholder="Approval Notes" value={POSTAUCT_LIEN_TAX_CLEARANCE["5"][`POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_5`]} 
						onChange={POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_5_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_5_5"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '3000ch' }}>
						 {t(`Enter Approval Notes`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_9_0"  value={POSTAUCT_LIEN_TAX_CLEARANCE["9"][`POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_9_0`]} onChange={POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_9_1" type="text" className="form-control" placeholder="Created By" value={POSTAUCT_LIEN_TAX_CLEARANCE["9"][`POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_9_1`]} 
						onChange={POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_9_2" type="text" className="form-control" placeholder="Created At" value={POSTAUCT_LIEN_TAX_CLEARANCE["9"][`POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_9_2`]} 
						onChange={POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_9_3" type="text" className="form-control" placeholder="Updated By" value={POSTAUCT_LIEN_TAX_CLEARANCE["9"][`POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_9_3`]} 
						onChange={POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_9_4" type="text" className="form-control" placeholder="Updated At" value={POSTAUCT_LIEN_TAX_CLEARANCE["9"][`POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_9_4`]} 
						onChange={POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["POST_AUCTION_02_LEGAL_TITLE_LIEN_REDEMPTION_CLEARANCE_POSTAUCT_LIEN_TAX_CLEARANCE_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default POSTAUCT_Lien_Tax_Clearance;  